import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { logoutUserRetrait } from "../../store/actions";

//redux
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const LogoutRetrait = () => {
  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUserRetrait(history));
  }, []);

  return <></>;
};

LogoutRetrait.propTypes = {
  history: PropTypes.object,
};

export default withRouter(LogoutRetrait);